import React from "react";
import dynamic from "next/dynamic";
const NoSSRNav = dynamic(() => import("./Nav"), { ssr: false });
import ScrollToTop from "./ScrollToTop";
const Mediaplayer = dynamic(() => import("./mediaplayer"), { ssr: false });
import ShareInitial from "./initialshare";
import ContextWrapper from "./SourceContextWrapper";
import Toggle from "./Toggle";
import CurrentPlayingStation from "./CurrentStationContextWrapper";
import AdblockDetected from "./AdblockFound";

const Layout = ({ children }) => {
  const {
    query,
    token,
    isopen,
    isActive,
    setQueryState,
    setCurMenuItem,
    setIsopen,
    handleToggle,
    closeSideBar,
    activeLink,
    inputText,
    moveToTop,
  } = Toggle();

  return (
    <div className="content">
      <CurrentPlayingStation>
        <ContextWrapper>
          <AdblockDetected />
          <NoSSRNav
            isopen={isopen}
            handleToggle={handleToggle}
            token={token}
            inputText={inputText}
            closeSideBar={closeSideBar}
            query={query}
            moveToTop={moveToTop}
            isActive={isActive}
            activeLink={activeLink}
            setIsopen={setIsopen}
            setQueryState={setQueryState}
            setCurMenuItem={setCurMenuItem}
          />
          {children}
          <ScrollToTop />
          <Mediaplayer />
          <ShareInitial /> 
        </ContextWrapper>
      </CurrentPlayingStation>
    </div>
  );
};

export default Layout;
